import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CoreModule as MainCoreModule } from '../../../core/core.module';

@NgModule({
    exports: [
        MainCoreModule
    ],
    imports: [
        CommonModule,
        MainCoreModule
    ],
    providers: [
        provideHttpClient(withInterceptorsFromDi())
    ]
})
export class CoreModule { }
